<template>
  <router-view name="feature" v-bind:key="$route.path"></router-view>
</template>

<script>
export default {
  name: "Feature",
};
</script>
